import { SET_VAULTING_ACTIVITY_CURRENT_PAGE } from '../actions/actionTypes';

const initialState = {
  currentPage: 0,
};

const vaultingActivityReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VAULTING_ACTIVITY_CURRENT_PAGE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default vaultingActivityReducer;
